<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  }
};
</script>

<style>
:root {
  --primary: #4e558a;
  --secondary: #d7e3fd;
  --label: #5a71c4;
  --special: #688eee;
  --success: #92d050;
  --error: #9b0d0d;
  --warning: #d38d24;
}
.theme--light.v-application {
  background: white;
}
@-webkit-keyframes autofill {
  to {
    color: white;
    background: transparent;
  }
}
@keyframes autofill {
  to {
    color: white;
    background: transparent;
  }
}
/*Change text in autofill textbox*/
input:-webkit-autofill {
  animation-name: autofill;
  -webkit-animation-name: autofill;
  animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
  -webkit-text-fill-color: white !important;
}
main {
  height: 100vh;
}
*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
*::-webkit-scrollbar {
  width: 5px;
  border-radius: 0 3px 3px 0;
  background-color: hsla(0, 0%, 96%, 0.44);
}
*::-webkit-scrollbar-thumb {
  background-color: var(--primary);
  border-radius: 2px;
}
input:-internal-autofill-selected {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0),
    inset 0 0 0 100px var(--label);
  color: -internal-light-dark-color(white, white) !important;
}
.container.container--fluid {
  margin: 0 auto !important;
}
.no-wrap {
  flex-wrap: nowrap !important;
}
.is-clickable:not(.disabled) {
  cursor: pointer;
}
.v-card__title {
  word-break: break-word !important;
}
.card-text-color {
  color: rgba(0, 0, 0, 0.87) !important;
}
.portal-tooltip.v-tooltip__content {
  background-color: var(--primary) !important;
  padding: 5px 16px !important;
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: bold !important;
  font-style: italic !important;
}
.portal-tooltip-inverted.v-tooltip__content {
  background-color: #ffffff !important;
  padding: 5px 16px !important;
  color: var(--primary) !important;
  font-size: 15px !important;
  font-weight: bold !important;
  font-style: italic !important;
}
.booking-timeline-tooltip.v-tooltip__content {
  background-color: var(--success) !important;
  padding-left: 5px 16px !important;
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: bold !important;
  font-style: italic !important;
}
.official-logo-login {
  width: 278px !important;
  height: 84px !important;
}
.official-logo {
  width: 278px !important;
  height: 84px !important;
}
.h36-medium {
  font-size: 36px;
  font-weight: 500;
  margin-top: -16px;
}
.height-spacer {
  min-height: 30px;
}
.v-application .v-card__title .title,
.v-application .v-card__text .title {
  line-height: 1.25rem;
}
.g-3 {
  gap: 12px;
}
</style>
